import { CreatedReport, ExpiredReport, FailedReport } from '../../interfaces';

export type DeletedReport = CreatedReport | ExpiredReport | FailedReport;

export enum DELETE_REPORT_BUSINESS_ERRORS {
  REPORT_NOT_FOUND = 'REPORT_NOT_FOUND'
}

export type HandleDeleteReportRequest = (id: string) => Promise<Response>;
export type HandleOpenDeleteDialog = (item: DeletedReport) => void;
